import { Routes, Route } from "react-router";
import TransactionsResults from './views/results'
import TransactionsRequests from './views/main'
import { Navigate } from "react-router-dom";

const TransactionsView = (props) => {
    return (
        <>
            <Routes>
                <Route path="list" element={<TransactionsRequests />} />
                <Route path="list/:transactionid" element={<TransactionsRequests />} />
                <Route path="details/:transactionid" element={<TransactionsResults />} />
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default TransactionsView